import classes from './Card.module.css'

const Card = (props) => {
    return (
        <div className={classes.card}>
            {props.children}
            
        </div>
    )
}

export default Card;

//props.children allows to pass the data. So whataver is passed between the opening anc closing tages of card component 
//gets passed on